import { defineComponent as _defineComponent } from 'vue'

import { ref, computed, onMounted, defineComponent } from 'vue';

import { useEventListener } from '@composables';
import { Promotion } from '@interfaces';
import { useStore } from '@store';
import { delay } from '@tools/delay';
import { isNumber } from '@tools/type-guards';

import ParallaxLayer, { Props } from '@components/ParallaxLayer.vue';
import StatusAlertBanner from '@components/StatusAlertBanner.vue';
import ZephyrLogo from '@components/SVGs/ZephyrLogo.vue';

import parallax1 from '@assets/images/parallax1.svg';
import parallax2 from '@assets/images/parallax2.svg';
import parallax3 from '@assets/images/parallax3.svg';
import parallaxForeground from '@assets/images/parallax-foreground.svg';
import parallaxDrone from '@assets/images/parallax-drone.png';

import MainSectionNavbarPromotions from './MainSectionNavbarPromotions.vue';

/** ... */
type LayerInstance = InstanceType<typeof ParallaxLayer>;

/**
 * ...
 */
interface ParallaxLayerConfig extends Props {
  className: string;
  key: string;
}

/** ... */
const PARALLAX_LAYER_CONFIGS: ParallaxLayerConfig[] = [
  {
    className: 'l1',
    key: 'l1',
    index: -4,
    depth: 0.25,
    yOffset: 200,
    bgSize: '130%',
    bgImage: parallax1,
  },
  {
    className: 'l2',
    key: 'l2',
    index: -3,
    depth: 0.5,
    yOffset: 220,
    bgSize: '130%',
    bgImage: parallax2,
  },
  {
    className: 'l3',
    key: 'l3',
    index: -2,
    depth: 0.75,
    yOffset: 200,
    bgSize: '130%',
    bgImage: parallax3,
  },
  {
    className: 'l4',
    key: 'l4',
    index: -1,
    depth: 1,
    yOffset: 200,
    bgSize: '130%',
    bgImage: parallaxForeground,
  },
  {
    className: 'l5',
    key: 'l5',
    index: -1,
    depth: 0.5,
    yOffset: 150,
    bgSize: '4%',
    bgPos: '59% 15%',
    bgImage: parallaxDrone,
  },
];

for (const item of PARALLAX_LAYER_CONFIGS) {
  if (isNumber(item.yOffset)) item.yOffset -= 150;
}

const __default__ = defineComponent({ name: 'MainSectionHero' });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const parallaxLayers = ref<LayerInstance[]>([]);

const store = useStore();

const displayMode = computed(() => {
  return store.state.displayMode;
});

const showLogo = ref(false);

const promotions = computed(() => {
  const promos = store.state.promotions.items.map((promo) => ({
    id: promo.id,
    body: promo.body,
    title: promo.title,
    shortText: promo.shortText ?? null,
    navbarText: promo.navbarText ?? null,
    navbarTextMobile: promo.navbarTextMobile ?? null,
    navbarBackgroundColor: promo.navbarBackgroundColor ?? null,
    callToAction: promo.callToAction ?? null,
    url: promo.url ?? null,
    image: promo.image ?? null,
  })) as Promotion[];

  return promos.length ? promos : null;
});

useEventListener('load', updateSceneParallaxing);
useEventListener('resize', updateSceneParallaxing);
useEventListener('scroll', updateSceneParallaxing);

onMounted(() => {
  void getSiteStatusInfo();

  void delay(750).then(() => (showLogo.value = true));
});

async function getSiteStatusInfo() {
  const response = await fetch('https://status.zephyr-sim.com/feed.rss');

  const data = await response.text();

  console.log(data);
}

/**
 * ...
 */
function updateSceneParallaxing() {
  if (displayMode.value === 'desktop') {
    for (const layer of parallaxLayers.value ?? []) layer.updatePosition();
  }
}

return { __sfc: true,PARALLAX_LAYER_CONFIGS, parallaxLayers, store, displayMode, showLogo, promotions, getSiteStatusInfo, updateSceneParallaxing, ParallaxLayer, StatusAlertBanner, ZephyrLogo, MainSectionNavbarPromotions }
}

})